import { Link, useLocation } from 'react-router-dom';

import { notNil } from '@/lib/utils';
import { useTitle } from '@/lib/hooks/use-title';
import { useGAPageview } from '@/lib/ga/use-ga';

import { getOAuthSession } from '../oauth/oauth-config';
import { OAuthLogin } from '../oauth/oauth-login';
import { LoginCards } from './login-cards';

import commonStyles from '../public.module.scss';

export const LoginPage = () => {
  useTitle('Login');
  useGAPageview();

  const location = useLocation();
  const oauthSession = getOAuthSession(location.search);

  if (notNil(oauthSession)) {
    return <OAuthLogin oauthSession={oauthSession} />;
  }

  return (
    <div className={commonStyles.layout}>
      <h1>Log In</h1>
      <LoginCards />
      <p>
        Don&apos;t have an account yet? <Link to="/signup">Sign up</Link>
      </p>
    </div>
  );
};
